<script setup>
import { ref, watch } from 'vue';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor.vue';
import { MESSAGE_SIGNATURE_EDITOR_MENU_OPTIONS } from 'dashboard/constants/editor';
import NextButton from 'dashboard/components-next/button/Button.vue';
import SignatureType from './SignatureType.vue';

const props = defineProps({
  messageSignature: {
    type: String,
    default: '',
  },
  signatureType: {
    type: String,
    default: 'bottom',
  },
});

const emit = defineEmits(['updateSignature']);
const customEditorMenuList = MESSAGE_SIGNATURE_EDITOR_MENU_OPTIONS;
const signature = ref(props.messageSignature);
const signatureType = ref(props.signatureType);
watch(
  () => props.signatureType ?? '',
  newValue => {
    signatureType.value = newValue;
  }
);
watch(
  () => props.messageSignature ?? '',
  newValue => {
    signature.value = newValue;
  }
);

const updateSignatureType = type => {
  signatureType.value = type;
};

const updateSignature = () => {
  emit('updateSignature', signature.value, signatureType.value);
};
</script>

<template>
  <form class="flex flex-col gap-6" @submit.prevent="updateSignature()">
    <WootMessageEditor
      id="message-signature-input"
      v-model="signature"
      class="message-editor h-[10rem] !px-3"
      is-format-mode
      :placeholder="$t('PROFILE_SETTINGS.FORM.MESSAGE_SIGNATURE.PLACEHOLDER')"
      :enabled-menu-options="customEditorMenuList"
      :enable-suggestions="false"
      show-image-resize-toolbar
    />
    <SignatureType
      :value="signatureType"
      :label="
        $t('PROFILE_SETTINGS.FORM.MESSAGE_SIGNATURE.SIGNATURE_TYPE.TITLE')
      "
      :description="
        $t('PROFILE_SETTINGS.FORM.MESSAGE_SIGNATURE.SIGNATURE_TYPE.NOTE')
      "
      @change="updateSignatureType"
    />
    <div>
      <NextButton
        type="submit"
        :label="$t('PROFILE_SETTINGS.FORM.MESSAGE_SIGNATURE_SECTION.BTN_TEXT')"
      />
    </div>
  </form>
</template>
